import { ORG_NAME, SITE_NAME, SITE_URL, absoluteUrl } from "@/lib/seo/config";

/**
 * schema.org JSON-LD builders. Each returns a plain object to pass to <Seo jsonLd={...} />.
 * Keep output factual: only describe content that is visible on the page.
 */

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: ORG_NAME,
    alternateName: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/A-Learning-Lab-Logo.png`,
  };
}

/** items: [{ name, path }] in order, starting from Home. */
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

/** faqs: [{ q, a }] — must match the FAQ text rendered on the page. */
export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  };
}

/** One programme detail page. Deliberately has no price or dates: those change per cohort and are shown on the page only. */
export function courseSchema({ name, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    name,
    description,
    url: absoluteUrl(path),
    provider: { "@type": "EducationalOrganization", name: ORG_NAME, url: SITE_URL },
  };
}

/** programs: normalized programs (src/lib/programs.js). Lists them as Course entries. */
export function programListSchema(programs, { name }) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    itemListElement: programs.map((program, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Course",
        name: program.title,
        description: program.summary || undefined,
        image: program.image,
        provider: { "@type": "EducationalOrganization", name: ORG_NAME, url: SITE_URL },
        ...(program.price
          ? {
              offers: {
                "@type": "Offer",
                price: program.price.amount,
                priceCurrency: program.price.currency,
                category: "Paid",
              },
            }
          : {}),
      },
    })),
  };
}
